import type { Fallacy } from "./types";
import { createStory } from "./types";

export const tuQuoque: Fallacy = {
    id: "tu-quoque",
    name: "Tu Quoque",
    emoji: "🪞",
    category: "Menyerang Lawan",
    description:
      "Mengalihkan kritik dengan menunjukkan bahwa **si pengkritik juga melakukan** hal yang sama, tanpa **menjawab intinya**.",
    detail:
      "Tu Quoque (dibaca: 'tu kwo-kwe') berasal dari bahasa Latin yang artinya 'kamu juga'. Ini bentuk khusus Ad Hominem — alih-alih menjawab argumen, kamu **menyerang konsistensi si pembicara**.\n\nKenapa ini fallacy? Karena **hipokrit atau tidaknya si pembicara tidak mengubah kebenaran argumennya**. Seorang perokok yang bilang 'rokok berbahaya' tetap benar, meskipun dia sendiri masih merokok.\n\nCara melawan: Akui ketidakkonsistenanmu jika memang ada, tapi kembalikan fokus ke argumen asli. \"Iya, saya juga masih proses. Tapi bukan itu yang kita bahas.\"",
    tldr: "Dikritik malah bales 'kamu juga!' — klasik Tu Quoque, gak jawab inti masalah.",
    story: createStory("Tu Quoque", "🪞", {
      hook: {
        title: "Kamu ngasih kritik yang bener...",
        body: "Tapi balesannya? **\"Ngaca dulu dong, kamu juga sama!\"** Inti kritiknya gak dijawab.",
      },
      convo: {
        claim: "Lah kamu tiap malem makan mie instan. **Ngaca dulu baru nasihatin orang.** Sok sehat banget!",
        response: "Hipokrit atau nggaknya si pembicara **gak ngubah fakta bahwa rokok itu berbahaya.**",
      },
      reveal: {
        body: "Artinya **\"kamu juga!\"** — ngalihin kritik dengan nunjukin bahwa si pengkritik juga gak sempurna. Tapi **hipokrit atau nggaknya si pembicara gak ngubah kebenaran argumennya**.",
      },
      insight: {
        title: "Intinya?",
        body: "Perokok yang bilang \"rokok bahaya\" tetap **bener**. Hipokrit atau nggak, itu urusan lain — **isi pesannya gak berubah**.",
      },
      engagement: {
        title: "Pernah dikritik terus balesnya \"kamu juga!\"?",
        body: "Jujur, kamu lebih sering jadi yang ngelakuin atau yang kena? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["ad-hominem", "red-herring", "straw-man"],
  };
